import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Grid, CircularProgress } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useSelector, useDispatch } from 'react-redux';
import { getCurrentProfile } from '../../../actions/profile';
import { getUserbyId } from '../../../actions/users';

import ServiceImages from '../../../components/services/detail/ServiceImages';
import ServiceHeaderInfo from '../../../components/services/detail/ServiceHeaderInfo';
import ServiceReviews from '../../../components/services/detail/ServiceReviews';
import ServiceContent from '../../../components/services/detail/ServiceContent';
import ServiceLocation from '../../../components/services/detail/ServiceLocation';

const ServiceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profile = useSelector(state => state.profile.profile);
  const loading = useSelector(state => state.profile.loading);
  const [service, setService] = useState(null);
  const [ownerUser, setOwnerUser] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!profile || Object.keys(profile).length === 0) {
      dispatch(getCurrentProfile());
    }
  }, [dispatch, profile]);

  useEffect(() => {
    const fetchOwnerInfo = async (userId) => {
      try {
        const user = await getUserbyId(userId);
        setOwnerUser(user);
      } catch (error) {
        console.error("Error fetching owner info:", error);
      }
    };

    if (profile && Object.keys(profile).length > 0 && !loading) {
      if (profile.servicios && profile.servicios.length > 0) {
        const found = profile.servicios.find(s => s._id === id);
        if (found) {
          setService(found);
          if (profile.user && !ownerUser) {
            fetchOwnerInfo(profile.user);
          }
        } else {
          navigate('/user/servicios', { replace: true });
        }
      } else {
        navigate('/user/servicios', { replace: true });
      }
    }
  }, [profile, id, ownerUser]);

  if (loading || !service) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', bgcolor: 'grey.50' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', pb: 8, pt: 2, mt: 10 }}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBackIosIcon />}
        onClick={() => navigate(-1)}
        sx={{
          textTransform: 'none',
          color: 'primary.main',
          fontWeight: 'bold',
          mb: 2,
          '&:hover': { bgcolor: 'transparent', opacity: 0.8 }
        }}
      >
        Atrás
      </Button>

      {/* Images Grid */}
      <ServiceImages id={service._id} images={service.img} />

      {/* Header Info (Title, Price, Stats) */}
      <ServiceHeaderInfo service={service} isOwner={true} />

      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 5 }}>
          <ServiceLocation service={service} profile={profile} user={ownerUser} />
          <ServiceReviews
            servicioId={service._id}
            ratingPromedio={service.ratingPromedio}
            nombreProveedor={ownerUser ? `${ownerUser.name} ${ownerUser.apellido}` : profile?.nombre}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <ServiceContent
            service={service}
            profile={profile}
            user={ownerUser}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServiceDetail;
